<script>
  // Перенос src_ui/web/src/screens/Identity.tsx — дословно.
  import { nuiPost, autofocus } from './nui';
  import Wiz from './wiz.svelte';

  const NAME_RE = /^[A-Za-z]{2,20}$/;

  export let onDone = () => {};
  export let onBack = null;

  let firstName = '';
  let lastName = '';
  let gender = null;
  let age = 23;
  let error = '';

  const submit = () => {
    if (/[А-Яа-яЁё]/.test(firstName + lastName)) {
      error = 'Имя и фамилия — только латиницей. Например: John Maverick.'; return;
    }
    if (!NAME_RE.test(firstName.trim())) { error = 'Имя: 2–20 латинских букв.'; return; }
    if (!NAME_RE.test(lastName.trim())) { error = 'Фамилия: 2–20 латинских букв.'; return; }
    if (!gender) { error = 'Выберите пол персонажа.'; return; }
    error = '';
    const id = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      age,
      gender,
    };
    nuiPost('identityDone', { ...id, backstory: '' });
    onDone(id);
  };
</script>

<Wiz step={1} {error} backHidden={!onBack} onBack={onBack ?? (() => {})} nextLabel="Далее" onNext={submit}>
  <div class="wizbody">
    <div class="wizsub">Кто прилетает в Лос-Сантос? Имя — только латиницей.</div>

    <div class="grid2">
      <div class="fld">
        <label>Имя</label>
        <input
          value={firstName}
          placeholder="John"
          spellcheck="false"
          use:autofocus
          maxlength="20"
          on:input={(e) => { firstName = e.target.value; error = ''; }}
        />
      </div>
      <div class="fld">
        <label>Фамилия</label>
        <input
          value={lastName}
          placeholder="Maverick"
          spellcheck="false"
          maxlength="20"
          on:input={(e) => { lastName = e.target.value; error = ''; }}
        />
      </div>
    </div>

    <div class="fld">
      <label>Пол</label>
      <div class="segpick">
        <div class={'opt' + (gender === 'm' ? ' on' : '')} on:click={() => { gender = 'm'; error = ''; }}>Мужчина</div>
        <div class={'opt' + (gender === 'f' ? ' on' : '')} on:click={() => { gender = 'f'; error = ''; }}>Женщина</div>
      </div>
    </div>

    <div class="sliderblock">
      <div class="head">
        <span class="lab" style="font:700 11px var(--f-body);letter-spacing:0.13em;text-transform:uppercase;color:var(--ink-soft)">Возраст</span>
        <span class="val big">{age}</span>
      </div>
      <input
        class="rng"
        type="range"
        min="18"
        max="80"
        value={age}
        on:input={(e) => { age = Number(e.target.value); }}
      />
      <div class="ends"><span>18</span><span>80</span></div>
    </div>
  </div>
</Wiz>
